// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"vb-z","heading":"wb-z","screenReadersOnly":"xb-z"};